import React from "react";
import PropTypes from "prop-types";
import { Box, Typography, FormControl } from "@mui/material";
import DatePicker from "react-datepicker";
import styled from "styled-components";
import "react-datepicker/dist/react-datepicker.css";
import { ReactComponent as ExpandChevronIcon } from "assets/images/icons/blue-downward-arrow.svg";
import "assets/styles.css";

const StyledDatePicker = styled(DatePicker)`
  .react-datepicker__input-container input {
    border: none;
    overflow: hidden;
    color: var(--Custom-Primary-Blue, #2732d4);
    text-overflow: ellipsis;
    font-family: "Biotif", sans-serif;
    font-size: 1.143vw;
    font-style: normal;
    font-weight: 400;
    line-height: 1.714vw;
    letter-spacing: 0.036vw;
  }
`;

function DateRangeField({
  label,
  selected,
  onChange,
  minDate,
  maxDate,
  disabled,
}) {
  return (
    <Box className="DateFilterBox">
      <Typography className="DateFilterBoxTypo">{label}</Typography>
      <FormControl variant="outlined" fullWidth className="DateFilterBoxForm">
        <StyledDatePicker
          selected={selected}
          onChange={onChange}
          dateFormat="dd MMM yyyy"
          wrapperClassName="datePicker"
          minDate={minDate}
          maxDate={maxDate}
          disabled={disabled}
        />
        <Box className="DateFilterBoxInner">
          <ExpandChevronIcon
            className="DateFilterImgStyle"
            aria-hidden="true"
          />
        </Box>
      </FormControl>
    </Box>
  );
}

DateRangeField.propTypes = {
  label: PropTypes.string.isRequired,
  selected: PropTypes.instanceOf(Date),
  onChange: PropTypes.func.isRequired,
  minDate: PropTypes.instanceOf(Date),
  maxDate: PropTypes.instanceOf(Date),
  disabled: PropTypes.bool,
};

DateRangeField.defaultProps = {
  selected: null,
  minDate: null,
  maxDate: null,
  disabled: false,
};

export default DateRangeField;
